import type { PublicHistoryDay } from "@/v2-status-client/status/status.types"
import { formatUptimePercent } from "@/v2-status-client/status/status.utils"

// YYYY-MM-DD in UTC, matching the `date` field shape the backend
// emits (PublicHistoryDay.Date is "2026-04-27", UTC-anchored).
export function todayUtcKey(): string {
  const now = new Date()
  const y = now.getUTCFullYear()
  const m = String(now.getUTCMonth() + 1).padStart(2, "0")
  const d = String(now.getUTCDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}

// Tooltip copy for a single history-bar cell. Customer vocabulary,
// not engineer vocabulary -- "unavailable" / "partial disruption"
// rather than "down" / "degraded".
export function describeDay(d: PublicHistoryDay): string {
  if (d.uptimePercent == null) return "no data"
  if (d.status === "down") {
    return `unavailable (${formatUptimePercent(d.uptimePercent)})`
  }
  if (d.status === "degraded") {
    return `partial disruption (${formatUptimePercent(d.uptimePercent)})`
  }
  return `${formatUptimePercent(d.uptimePercent)} uptime`
}
